import { useSelector } from 'react-redux';
import { Box, Icon } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './showings.module.scss';
import ToolTip from '@/components/ToolTip/ToolTip';

export default function ShowingsLegend() {
  const { datasets } = useSelector((state) => state.DashboardSlice.showings);

  return (
    <Box className={styles.showingLegend}>
      {datasets.map((dataset) => (
        <Box key={dataset.label} className={styles.legendItem}>
          <Box
            className={styles.legendBadge}
            __css={{ backgroundColor: dataset.backgroundColor }}
          />
          <Box className={styles.legendName}>{dataset.label}</Box>
        </Box>
      ))}
      <ToolTip
        title={Trans(translations, 'ScheduledVisitsThatHaveNotYetTakenPlace')}
      >
        <Box>
          <Icon icon="icon-info" className={styles.icon} />
        </Box>
      </ToolTip>
    </Box>
  );
}
